export default {
  header: {
    appName: 'Ahora Patagonia',
    toggleMenu: 'Menu',
    notifications: 'Notifications',
    help: 'Help',
    userMenu: 'Account',
    menuProfile: 'My profile',
    menuLogout: 'Log out',
  },
  footer: {
    version: 'v{{version}} · © {{year}} Ahora Patagonia',
  },
  sections: {
    general: 'General',
  },
} as const;
